import gql from 'graphql-tag';
export class MyDocumentsMutations {
  static create = gql`
    mutation MyDocumentsCreateEmailVerification($deviceId: String!) {
      myDocumentsCreateEmailVerification(deviceId: $deviceId)
    }
  `;
  static verify = gql`
    mutation MyDocumentsVerifyEmail($code: Float!, $deviceId: String!) {
      myDocumentsVerifyEmail(code: $code, deviceId: $deviceId)
    }
  `;
}
